import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroSection from "../components/HeroSection"
import IntroSection from "../components/IntroSection"
import Process from "../components/Process"
import FeaturedProjects from "../components/FeaturedProjects"
import Interested from "../components/Interested"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Home" />
    <HeroSection img={data.img.childImageSharp.fluid} />
    <IntroSection />
    <Process />
    <FeaturedProjects />
    <Interested />
  </Layout>
)
export const query = graphql`
  {
    img: file(relativePath: { eq: "hero-image.png" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
export default IndexPage
